import gql from 'graphql-tag';

export const ANNOUNCE_QUERY = gql`
  query getSuperContentByUrl($url: String!) {
    SuperContent(Url: $url) {
      Id
      Url
      IxName
      Title
      Text
    }
  }
`;

export const ANNOUNCE_VARIABLES = {
  url: '/reklam',
};
